import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const WishlistPreview = ({ wishlistItems, onAddToCart }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Wishlist</h2>
        <Link to="/wishlist">
          <Button variant="outline" size="sm" iconName="ArrowRight" iconPosition="right">
            View All
          </Button>
        </Link>
      </div>
      
      {wishlistItems.length === 0 ? (
        <div className="text-center py-8">
          <Icon name="Heart" size={48} className="text-muted-foreground mx-auto mb-4" />
          <p className="text-muted-foreground mb-4">Your wishlist is empty</p>
          <Link to="/products">
            <Button variant="default">Browse Products</Button>
          </Link>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <div className="flex space-x-4 pb-2">
            {wishlistItems.map((item) => (
              <div key={item.id} className="flex-shrink-0 w-48 bg-background border border-border rounded-lg p-3 hover:shadow-elevation-1 transition-shadow">
                <div className="relative mb-3">
                  <div className="w-full h-32 bg-muted rounded-lg overflow-hidden">
                    <Image
                      src={item.image}
                      alt={item.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  {item.discount && (
                    <span className="absolute top-2 left-2 bg-error text-error-foreground text-xs font-medium px-2 py-1 rounded">
                      -{item.discount}%
                    </span>
                  )}
                </div>
                <div className="mb-3">
                  <h3 className="font-medium text-foreground text-sm mb-1 line-clamp-2">{item.name}</h3>
                  <div className="flex items-center space-x-2">
                    <span className="font-semibold text-foreground">${item.price.toFixed(2)}</span>
                    {item.originalPrice && (
                      <span className="text-xs text-muted-foreground line-through">
                        ${item.originalPrice.toFixed(2)}
                      </span>
                    )}
                  </div>
                  <div className="flex items-center mt-1">
                    <div className="flex items-center">
                      {[...Array(5)].map((_, i) => (
                        <Icon
                          key={i}
                          name="Star"
                          size={12}
                          className={i < Math.floor(item.rating) ? 'text-yellow-400 fill-current' : 'text-muted-foreground'}
                        />
                      ))}
                    </div>
                    <span className="text-xs text-muted-foreground ml-1">({item.reviews})</span>
                  </div>
                </div>
                <Button
                  variant="outline"
                  size="sm"
                  fullWidth
                  iconName="ShoppingCart"
                  iconPosition="left"
                  onClick={() => onAddToCart(item)}
                >
                  Add to Cart
                </Button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default WishlistPreview;